export default __webpack_public_path__ + "static/media/903.adf38622.png";